import { memo } from "react";

const Footer = () => {
  return (
    <footer className="bg-headerAndFooter">
      <p className="text-10px md:text-14px text-white text-center py-6px md:py-8px">
        米特鴨股份有限公司 版權所有 <br className=" md:hidden" />
        ©2023 Meteor Duck All Rights Reserved
      </p>
    </footer>
  );
};

export default memo(Footer);
